import { Extension } from '@tiptap/core';

const CustomKeyboardShortcuts = Extension.create({
  name: 'customKeyboardShortcuts',

  addOptions() {
    return {
      onSubmit: () => {},
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const suggestionTriggers = new Set(['@']); // Add more triggers if needed

        const text = editor.getText().trim();
        const hasImage = editor.getHTML().includes('<img');

        // Check if text is not empty or there's an image
        if (text === '' && !hasImage) {
          return false;
        }

        // Check if text only consists of trigger characters and there's no image
        if (suggestionTriggers.has(text) && !hasImage) {
          return false;
        }

        // check for tippy.js pop up
        const tippy = document.querySelector('.tippy-box');
        const { attributes } = tippy || {};
        if (
          attributes &&
          (attributes['data-state' as keyof typeof attributes] as Attr)
            .value === 'visible'
        ) {
          return false;
        }

        const isMobile = window.innerWidth <= 768;

        if (this.options.onSubmit && !isMobile) {
          this.options.onSubmit();
          return true;
        } else {
          editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.splitListItem('listItem'),
            () => commands.createParagraphNear(),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
          ]);
        }
        return false;
      },
      'Ctrl-Enter': ({ editor }) =>
        editor.commands.first(({ commands }) => [
          () => commands.newlineInCode(),
          () => commands.splitListItem('listItem'),
          () => commands.createParagraphNear(),
          () => commands.liftEmptyBlock(),
          () => commands.splitBlock(),
        ]),
      'Shift-Enter': ({ editor }) =>
        editor.commands.first(({ commands }) => [
          () => commands.newlineInCode(),
          () => commands.splitListItem('listItem'),
          () => commands.createParagraphNear(),
          () => commands.liftEmptyBlock(),
          () => commands.splitBlock(),
        ]),
    };
  },
});

export default CustomKeyboardShortcuts;
